import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["cpf", "nome", "button"]
  static values = { url: String }

  connect() {
    this.resolved = new Map()
    this.requests = new Map()
    this.change()
  }

  disconnect() {
    this.requests.forEach(request => request.abort())
  }

  digits(input) { return input.value.replace(/\D/g, "") }
  paste() { queueMicrotask(() => this.change()) }

  change() {
    const values = this.cpfTargets.map(input => this.digits(input))
    const iguais = values[0].length > 0 && values[0] === values[1]
    this.cpfTargets.forEach((input, index) => {
      const cpf = values[index]
      const nome = this.nomeTargets.find(target => target.dataset.papel === input.dataset.papel)
      if (iguais || this.resolved.get(input)?.cpf !== cpf) {
        this.resolved.delete(input)
        this.requests.get(input)?.abort()
        this.requests.delete(input)
        input.setCustomValidity(iguais ? "Informe CPFs diferentes." : "Identifique o sócio pelo CPF antes de continuar.")
        nome.textContent = iguais ? "O gestor e a pessoa administrada devem ter CPFs diferentes." : ""
        nome.classList.toggle("text-danger", iguais)
      }
      if (!iguais && cpf.length === 11 && !this.resolved.has(input) && !this.requests.has(input)) {
        this.lookup(input, cpf, nome)
      }
    })
    this.updateButton()
  }

  async lookup(input, cpf, nome) {
    const request = new AbortController()
    this.requests.set(input, request)
    nome.textContent = "Buscando sócio…"
    try {
      const url = new URL(this.urlValue, window.location.origin)
      url.searchParams.set("cpf", cpf)
      const response = await fetch(url, { signal: request.signal, headers: { Accept: "application/json" }, credentials: "same-origin", cache: "no-store" })
      const data = await response.json()
      if (this.requests.get(input) !== request || this.digits(input) !== cpf) return
      if (!response.ok || !data.nome) throw new Error(data.erro || "Não foi possível identificar o sócio.")
      this.resolved.set(input, { cpf })
      input.setCustomValidity("")
      nome.textContent = data.nome
      nome.classList.remove("text-danger")
    } catch (error) {
      if (request.signal.aborted || this.requests.get(input) !== request) return
      nome.textContent = error instanceof SyntaxError || error instanceof TypeError ? "Não foi possível consultar. Saia do campo para tentar novamente." : error.message
      nome.classList.add("text-danger")
      input.setCustomValidity("Identifique o sócio pelo CPF antes de continuar.")
    } finally {
      if (this.requests.get(input) === request) this.requests.delete(input)
      this.updateButton()
    }
  }

  updateButton() {
    this.buttonTarget.disabled = !this.cpfTargets.every(input => this.resolved.get(input)?.cpf === this.digits(input))
  }

  submit(event) {
    this.change()
    if (this.buttonTarget.disabled) {
      event.preventDefault()
      this.element.reportValidity()
    }
  }
}
